import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import Select from "react-select";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../../assets/img";
import { Table } from "../../../components/Table/Table";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import DateRange from "../../../components/DateRange/DateRange";
import { deletes, get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../../redux/api/PermissionManager";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../../components/StaticData";

const HomeBanner = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    city: "",
    state: "",
    search: paginationData?.[path]?.search ?? "",
  });
  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(false);
  const [url, setUrl] = useState();
  const [defaultBanner, setDefaultBanner] = useState({});
  const [bannerList, setBannerList] = useState([]);

  useEffect(() => {
    getLocationsList(2);
    getCities();
    fetch();
  }, []);

  //get  locations
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION + "?type=" + type}${
      parent_id ? "&parent_id=" + parent_id : ""
    }`;
    const res = await get(url);
    console.log("locations list", res, type, parent_id);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setOptionsList((prev) => ({ ...prev, states: modifiedList }));
      } else if (type === 3) {
        setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
      } else {
        setOptionsList((prev) => ({ ...prev, areas: modifiedList }));
      }
    }
  };

  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [selectedFilter.city, selectedFilter.state, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    const { city, from, state, search, to } = selectedFilter;
    const payload = new FormData();
    payload.append("type", 1);
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (state) {
      payload.append("state", state?.value);
    }
    const res = await post(URLS.BANNERS + "?page=" + pageNumber, payload);
    console.log("Home Banners", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setBannerList(res?.data);
    }
  };

  const fetch = async () => {
    try {
      const res = await get(`${URLS.MASTERURL}?type=${3}`);
      console.log("res banner home", res);
      setSelectedImage(res?.data[0]?.icon);
      setDefaultBanner(res?.data[0]);
      // setList(res?.results || res?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async () => {
    setBannerPopup(false);
    const formdata = new FormData();
    formdata.append("name", url);
    if (selectedImage && typeof selectedImage !== "string") {
      formdata.append("icon", selectedImage);
      console.log("formDataSSimage", selectedImage);
    }
    try {
      const res = await post(
        `${URLS.MASTERURL}${defaultBanner?.id}/edit/`,
        formdata,
      );
      console.log("res edit room category", res);

      setSelectedImage(null);
      if (res.status === "success") {
        toast.success(res.message || "Edited successfully");
        fetch();
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleStatus = async (id, status) => {
    if (!checkPermission("CAN-STATUS-BANNER")) return;
    let res = await post(`${URLS.BANNER_MASTER}${id}/status/`, {
      status: status ? 0 : 1,
    });
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const handleDelete = async (id) => {
    let res = await deletes(`${URLS.BANNER_MASTER}${id}/delete/`);
    if (res?.status === "success") {
      setPopup(false);
      toast.success("Role Deleted Successfully");
      getList();
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          return <p className="red">{row.index + 1 + (page - 1) * 10}</p>;
        },
      },
      {
        Header: "Image",
        accessor: "image",
        Cell: ({ value, row }) => {
          return (
            <img
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "10px",
              }}
              src={Boolean(value) ? value : dummyimage}
            />
          );
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          const states = row?.original?.states?.map((ele) => ele?.name) || [];

          return (
            <div>
              {row?.original?.all_states ? (
                <p>All States</p>
              ) : (
                <div>
                  {states.map((stateName, index) => (
                    <p key={index}>{stateName}</p>
                  ))}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "City",
        accessor: "city",

        Cell: ({ value, row }) => {
          const citys = row?.original?.cities?.map((ele) => ele?.name) || [];
          return (
            <div>
              {row?.original?.cities.length == 0 ||
              row?.original?.states.length > 1 ? (
                <p>All City</p>
              ) : (
                <div>
                  {/* {citys.map((stateName, index) => ( */}
                  <p>{citys.length}</p>
                  {/* ))} */}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Count",
        accessor: "count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "From Date",
        accessor: "start_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "To Date",
        accessor: "end_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original.id, value);
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            {checkPermission("CAN-EDIT-BANNER") && (
              <div className="d-flex ac-js gap-3">
                <button
                  onClick={() => {
                    navigate("/add-home-banners", {
                      state: { type: "edit", data: row.original },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={edit_icon} alt="" className=" edit-btn " />
                </button>
                {checkPermission("CAN-DELETE-BANNER") && (
                  <button
                    onClick={() => setPopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            )}
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-EDIT-BANNER") ||
      checkPermission("CAN-DELETE-BANNER")
      ? [...d, action]
      : d;
  }, [page]);

  return (
    <div>
      <Topbar header={"Banner"} subHead={"Home Banner"} />

      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2>
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.states}
          isClearable
          onChange={(e) => {
            handleChangeFilter("state", e);
          }}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          value={selectedFilter?.state}
          placeholder={"State"}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
        {checkPermission("CAN-ADD-BANNER") && (
          <button
            onClick={() =>
              navigate("/add-home-banners", {
                state: { type: "add" },
              })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            {" "}
            + Add New
          </button>
        )}
      </div>

      <div className="mt-5">
        <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
          Default Banner
        </h2>
        <p className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ">
          {" "}
          Max Upload Size : 5MB and Banner Size 1200px 700px*{" "}
        </p>
        <div
          className="mt-3"
          style={{
            border: "1px solid #C5C5C5",
            borderRadius: "20px",
            width: "25%",
          }}
        >
          <div
            className="d-flex ac-jb p-2"
            style={{ borderBottom: "1px solid #C5C5C5" }}
          >
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 w-60">
              Image
            </p>
            {checkPermission("CAN-EDIT-BANNER") && (
              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 w-40">
                Action
              </p>
            )}
          </div>
          <div className="d-flex ac-jb p-2">
            <div className="w-60">
              <div className=" mb-2 w-100 d-flex ac-jb">
                <div className="position-relative w-100">
                  <div className="d-flex ac-jb w-100">
                    <div>
                      {typeof defaultBanner?.icon === "string" ? (
                        // Case: image is a URL from backend
                        <img
                          alt="not found"
                          style={{ width: "60px", height: "50px" }}
                          src={defaultBanner?.icon || dummyimage}
                        />
                      ) : defaultBanner?.icon instanceof File ? (
                        // Case: user uploaded a new file
                        <img
                          alt="not found"
                          style={{ width: "60px", height: "50px" }}
                          src={URL.createObjectURL(defaultBanner?.icon)}
                        />
                      ) : (
                        // Case: no image
                        <img
                          alt="not found"
                          style={{ width: "60px", height: "50px" }}
                          src={dummyimage}
                        />
                      )}

                      <input
                        style={{
                          position: "absolute",
                          width: "60px",
                          height: "50px",
                          left: "0px",
                          top: "0px",
                        }}
                        type="file"
                        hidden
                        name="myImage"
                        accept="image/*"
                        ref={inputRef}
                        onChange={(e) => setSelectedImage(e.target.files[0])}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {checkPermission("CAN-EDIT-BANNER") && (
              <button className="cust-btn d-flex ac-js w-40">
                <img
                  src={edit_icon}
                  onClick={() => {
                    setSelectedImage(defaultBanner?.icon);
                    setUrl(defaultBanner?.name);
                    setBannerPopup(true);
                  }}
                  alt=""
                  className="mx-2 edit-btn "
                />
              </button>
            )}
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={bannerList}
        show={true}
      />
      {bannerPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                Edit
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setBannerPopup(false);
                }}
                className="pointer"
              />
            </div>
            <div className=" px-2 mt-4">
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                Icon
              </p>
              <div className="d-flex ac-jb gap-3">
                <div className="">
                  <div className=" w-100 d-flex ac-jb">
                    <div
                      onClick={() => {
                        inputRef.current.click();
                      }}
                      className="position-relative w-100"
                    >
                      <div className="d-flex ac-jb w-100">
                        <div>
                          {typeof selectedImage === "string" ? (
                            <img
                              alt="not found"
                              style={{
                                width: "60px",
                                height: "50px",
                                borderRadius: "10px",
                              }}
                              src={selectedImage ? selectedImage : dummyimage}
                            />
                          ) : selectedImage?.name ? (
                            <img
                              alt="not found"
                              style={{
                                width: "60px",
                                height: "50px",
                                borderRadius: "10px",
                              }}
                              src={URL.createObjectURL(selectedImage)}
                            />
                          ) : (
                            <img
                              alt="not found"
                              style={{
                                width: "60px",
                                height: "50px",
                                borderRadius: "10px",
                              }}
                              src={dummyimage}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <input
                  type="url"
                  value={url}
                  onChange={(e) => {
                    setUrl(e.target.value);
                  }}
                  placeholder="Enter URL"
                  className="input-box"
                />
              </div>
              <button
                onClick={() => {
                  handleSubmit();
                  // logout();
                }}
                className="submit-btn f2 w-60 mt-3"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}Save
              </button>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(popup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeBanner;
